<template>
  <tr :class="className">
    <td>
      <div style="width: 150px">
        <a class="btn btn-danger m-0 customer-payin text-white" @click="openResellerAccount(customer.id)">
          <i class="fa fa-desktop"></i>
        </a>
        <router-link v-if="type === 'admin'" :to="{name: 'AdminInfo', params: {id: customer.id}}" tag="a" class="btn btn-info m-0 text-white">
          <i class="fa fa-eye"></i>
        </router-link>
        <router-link v-if="type === 'reseller'" :to="{name: 'AdminInfo', params: {id: customer.id}, query: {referrer: referrer}}" tag="a" class="btn btn-info m-0 text-white">
          <i class="fa fa-eye"></i>
        </router-link>
        <a href="javascript:;" v-if="!showSubUsers" @click="subUser(customer.id)" class="btn btn-info get-subdealers" title="Alt bayilerini göster">
          <i class="fa fa-angle-double-down"></i>
        </a>
      </div>
    </td>
    <td>
      <router-link v-if="type === 'reseller'" :to="{name: 'CustomerList', query: {referer: customer.id}}">
        <i class="fa fa-sort-amount-desc"></i>
      </router-link>
      {{ customer.fullName }}
    </td>
    <td>
      {{ balance.casino_profit }}
    </td>
    <td>
      {{ balance.bet_profit }}
    </td>
    <td>
      {{ balance.card_balance }}
    </td>
    <td>
      {{ customer.balance }}
    </td>
    <td>
      {{ customer.lastActivityAt | timeAgo }}
    </td>
  </tr>
</template>

<script>
export default {
  name: "AdminTableRow",
  props: ['customer', 'akey', 'className', 'type', 'referrer'],
  data() {
    return {
        showSubUsers: false,
        balance: {}
    }
  },
  mounted() {
    this.fetchBalance();
  },
  methods: {
    fetchBalance(){
      this.$http.get(api + 'api/v1/reseller_giro/'+this.customer.id)
          .then(response => {
              this.balance = response.body.result.data;
          }, response => {

          })
    },
    openPayinModal(user, operate) {
      this.$bus.$emit('payinModal', {id: user, action: true, operate: operate})
    },
    subUser(uid){
      this.showSubUsers = true;
      this.$emit('result', {uid: uid, key: this.akey});
    },
    openResellerAccount(uid) {
      this.createToken(uid)
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/row/AdminTableRow.vue